import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { XCircle, CreditCard, Loader2 } from "lucide-react";
import { createCheckoutSession } from "@/lib/api";

const PaiementAnnule = () => {
  const [searchParams] = useSearchParams();
  const rid = searchParams.get("rid");
  const stageSlug = searchParams.get("stage");
  const stageType = searchParams.get("stype");
  const [retrying, setRetrying] = useState(false);

  const stagePath = stageSlug
    ? `${stageType === "stage_pro_semi_pro" ? "/stage-pro" : "/stage-payet"}/${stageSlug}`
    : "/stage-payet";

  const retryPayment = async () => {
    if (retrying || !rid) return;
    setRetrying(true);
    try {
      const { checkout_url } = await createCheckoutSession(rid);
      window.location.href = checkout_url;
    } catch (err) {
      toast.error(err.message);
      setRetrying(false);
    }
  };

  return (
    <div data-testid="payment-cancel-page" className="min-h-screen flex items-center justify-center px-6 pt-20">
      <div className="max-w-xl w-full bg-noir-surface border border-noir-border p-8 md:p-12 text-center">
        <XCircle size={56} className="text-rouge mx-auto" />
        <h1 className="mt-6 font-display uppercase text-4xl md:text-5xl tracking-wide">
          Paiement <span className="text-gold">annulé</span>
        </h1>
        <p className="mt-4 text-white/60 leading-relaxed">
          Votre inscription n'a pas été confirmée et aucune place n'a été débitée.
          Vos informations sont conservées : vous pouvez reprendre le paiement quand vous le souhaitez.
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          {rid && (
            <button
              type="button"
              data-testid="retry-payment-button"
              onClick={retryPayment}
              disabled={retrying}
              className="inline-flex items-center gap-3 px-8 py-4 bg-rouge text-white text-sm font-bold uppercase tracking-[0.15em] rounded-full hover:bg-rouge-hover hover:scale-[1.02] active:scale-95 transition-all shadow-[0_0_20px_rgba(230,0,0,0.3)] disabled:opacity-60"
            >
              {retrying ? <Loader2 size={16} className="animate-spin" /> : <CreditCard size={16} />}
              {retrying ? "Redirection…" : "Reprendre le paiement"}
            </button>
          )}
          <Link
            to={stagePath}
            data-testid="cancel-back-to-stage"
            className="px-8 py-4 border-2 border-gold text-gold text-sm font-bold uppercase tracking-[0.15em] rounded-full hover:bg-gold hover:text-noir transition-all"
          >
            Retourner au stage
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PaiementAnnule;
